import React from 'react';

export default class Html5Player extends React.Component {


    componentDidMount() {
        this.player = document.getElementById('player-video-html5');
        
        window.sdk.player(this.player);        
        this.playerDurationNotified = false; 
        this.player.onplay = function () {
            /*window.sdk.live.isLive = {
                live: true
            }*/
            if(!this.playerDurationNotified) {
                this.playerDurationNotified = true;
                let i = setInterval(() => {
                  if(window.sdk.player().getRealDuration() > -15) {
                    window.sdk.emit('play');
                    clearInterval(i);
                  }
                }, 300)
            }
            /*if(window.live) {
                window.sdk.isLive = {
                live : true
                }
            }*/
        };        
    }

    render(){
    
    let style={
        background : '#000000',
        position: 'relative'
    }        
    return (
        <div id="player" style={style}>
          <video width="100%" height="100%" id="player-video-html5" controls src={this.props.videoUrl}>
          {window.subtitles && <track label="Sous titres" kind="subtitles" srclang="fr" src="media/soustitres.vtt" /> }
          </video>
        </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/Player/MediaPlayer/Html5Player.js